import "./index.css"

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { ApplicationLayout } from "@layouts/ApplicationLayout"

import { AdvancedSearchPage } from "@pages/AdvancedSearchPage"
import { ChatPage } from "@pages/ChatPage"
import { CollectionPage } from "@pages/CollectionPage"
import { CollectionsPage } from "@pages/CollectionsPage"
import { DashboardPage } from "@pages/DashboardPage"
import { DocumentPage } from "@pages/DocumentPage"
import { NotFoundPage } from "@pages/NotFoundPage"
import { SignInPage } from "@pages/SignInPage"

import { ProtectedRoutes } from "@routes/ProtectedRoutes"

import { UserSessionProvider } from "@session/UserSessionProvider"

export default function App() {
    return (
        <UserSessionProvider>
            <BrowserRouter>
                <ApplicationLayout>
                    <Routes>
                        <Route path="/login" element={<SignInPage />} />
                        <Route
                            path="/*"
                            element={
                                <ProtectedRoutes>
                                    <Routes>
                                        <Route path="/" element={<DashboardPage />} />
                                        <Route path="/document/:id" element={<DocumentPage />} />
                                        <Route path="/assistant" element={<ChatPage />} />
                                        <Route path="/search" element={<AdvancedSearchPage />} />
                                        <Route path="/collections" element={<CollectionsPage />} />
                                        <Route path="/collections/:cId" element={<CollectionPage />} />
                                        <Route path="/404" element={<NotFoundPage />} />
                                        <Route path="*" element={<Navigate to="/404" replace />} />
                                    </Routes>
                                </ProtectedRoutes>
                            }
                        />
                    </Routes>
                </ApplicationLayout>
            </BrowserRouter>
        </UserSessionProvider>
    )
}
